import * as requests from "../../coraWebComponents/utils/requests";
import urls from "../../constants/Urls";

const buildZP_C_STAV_ZIADOSTI = () => {
  return `${urls.ZP_C_STAV_ZIADOSTI}`;
};

export const getZP_C_STAV_ZIADOSTI = async () => {
  const url = buildZP_C_STAV_ZIADOSTI();
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};
